// extracted by mini-css-extract-plugin
module.exports = {"pageColor":"_1pvQSQoCrY-page-theme-landing-pageColor","pageMain":"qC36H928q_-page-theme-landing-pageMain"};